import { action } from 'satcheljs';

/**
 * Action called to initialize the expand/collapse state of folder nodes
 * from user configuration.
 */
export default action('initializeFolderViewStates');
